import { render, staticRenderFns } from "./BankSettings.vue?vue&type=template&id=e10ae822&scoped=true&"
import script from "./BankSettings.vue?vue&type=script&lang=js&"
export * from "./BankSettings.vue?vue&type=script&lang=js&"
import style0 from "./BankSettings.vue?vue&type=style&index=0&id=e10ae822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10ae822",
  null
  
)

export default component.exports